import { SyntheticEvent, useEffect, useState } from "react";
import clsx from "clsx";

// Interfaces
import { ISearch } from "./interfaces";

// MUI
import { IconButton, InputBase, Skeleton, Stack } from "@mui/material";

// Icons
import ClearIcon from "@mui/icons-material/Clear";
import { ReactComponent as SearchIcon } from "@/assets/icons/actions/search.svg";

const SearchInputIcon = (props: Readonly<ISearch>) => {
	const { value = "", clearSearch = () => {} } = props;
	return (
		<Stack justifyContent={"center"} alignContent={"center"} sx={{ marginRight: "10px" }}>
			<IconButton className="!p-[2px]" disabled={!value} aria-label="search-action-button" onClick={clearSearch}>
				{!value ? <SearchIcon className="text-default" /> : <ClearIcon className="!text-[1.3rem]" />}
			</IconButton>
		</Stack>
	);
};

export default function SearchInput(props: Readonly<ISearch>) {
	const { value = "", className = "", sx = null, disabled = false, loading = false, onChange = () => {}, clearSearch = () => {} } = props;
	const [search, setSearch] = useState("");

	const handleChange = (event: SyntheticEvent) => {
		const target = event.target as HTMLInputElement;
		setSearch(target.value);
		onChange?.(target.value);
	};

	const handleClearSearch = () => {
		setSearch("");
		clearSearch?.();
	};

	useEffect(() => {
		setSearch(value ?? "");
		return () => {
			setSearch("");
		};
	}, [value]);

	if (loading) {
		return (
			<Stack direction={"row"} alignContent={"center"} justifyContent={"center"}>
				<Skeleton variant="rectangular" width={"100%"} height={30} sx={{ borderRadius: "25px" }} />
			</Stack>
		);
	}

	return (
		<Stack
			direction={"row"}
			alignContent={"center"}
			justifyContent={"center"}
			className={clsx({
				"!h-[30px] !border !border-solid !border-disabled rounded-full": true,
				[className]: Boolean(className),
			})}
			sx={sx}
		>
			<InputBase
				size="small"
				placeholder="Search..."
				className="!font-sans !text-default !text-[14.5px]"
				value={search}
				disabled={disabled}
				sx={{ ml: "12px", flex: 1 }}
				inputProps={{ "aria-label": "search", className: "!pb-[3px]" }}
				onChange={handleChange}
			/>
			<SearchInputIcon value={search} clearSearch={handleClearSearch} />
		</Stack>
	);
}
